import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-reports',
  templateUrl: './data-reports.component.html',
  styleUrls: ['./data-reports.component.css']
})
export class DataReportsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
